<template>
  <div >
    <touch-header style="height: 100px;width: 100%;background-color: #008f47;"></touch-header>
    <div class="container" style="padding-top: 50px;text-align:center;">

      <el-form label-width="80px">
        <el-form-item label="标题" style="width: 839px">
          <el-input v-model="form.data.title"></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="img" style="margin-top: 27px;">
          <el-upload
            ref="uploadRef"
            style="text-align: left;"
            action="/api/imageUpload"
            :show-file-list="false"
            :on-success="handleImageSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="form.data.img" :src="'/api'+ form.data.img" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>

        </el-form-item>
        <el-form-item label="发布时间" style="text-align: left">
          <el-date-picker
            v-model="form.data.release"
            type="date"
            placeholder="选择日期"
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="内容">
          <!-- 图片上传组件辅助-->
          <el-upload
            class="avatar-uploader"
            action="/api/imageUpload"
            :show-file-list="false"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :before-upload="beforeUpload">
          </el-upload>
          <el-row v-loading="quillUpdateImg">
            <quill-editor
              class="editor ql-editor"
              v-model="form.data.detail"
              ref="myQuillEditor"
              :options="editorOption"
            >
            </quill-editor>
          </el-row>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="back">返 回</el-button>
            <el-button type="primary" @click="saveContent">确 定</el-button>
          </span>
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
// eslint-disable-next-line import/no-cycle
import { saveIndustry, getIndustry, updateIndustry } from '../../api/industry';
import TouchHeader from '../../components/TouchHeader.vue';

/**
   * 文件上传之前的回调函数
   */
function beforeAvatarUpload(file) {
  const flag = this.compareImage(file);
  if (!flag) {
    this.$confirm('上传文件必须为图片格式 ', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).catch(() => {
      //                关闭上传弹窗
    });
  }
  return flag;
}

/**
   *  判断上传文件是否为图片
   * @param file
   * SUN
   */
function compareImage(file) {
  let flag = true;
  const fileName = this.getLast3Str(file);
  if (fileName !== 'svg' && fileName !== 'png' && fileName !== 'jpg') {
    flag = false;
  }
  return flag;
}


async function newsDetails() {
  console.log('----', this.$route.query.id);
  const { id } = this.$route.query;
  if (id) {
    const res = await getIndustry(id);
    if (res.code === 1200) {
      this.$set(this.form.data, 'id', res.data.industry.id);
      this.$set(this.form.data, 'title', res.data.industry.title);
      this.$set(this.form.data, 'detail', res.data.industry.detail);
      this.$set(this.form.data, 'img', res.data.industry.img);
      this.$set(this.form.data, 'release', this.timestampToTime(res.data.industry.releaseAt));
    }
    console.log('----', this.form.data);
  }
}

/**
   * 上传成功
   */
function handleImageSuccess(res, file) {
  if (res.code === 1200) {
    this.imageUrl = URL.createObjectURL(file.raw);
    console.log('111', res);
    const img = res.data.path;
    this.$set(this.form.data, 'img', img);
  }
  console.log('', this.form.data.img);
}

/**
   * 获取上传文件的后缀名字符串 （后缀长度均为3）
   * @param file
   * @returns {string} SUN
   */
function getLast3Str(file) {
  const fileName = file.name;
  const index = fileName.lastIndexOf('.') + 1;
  return fileName.substring(index);
}

async function saveContent() {
  console.log('asas', this.form.data);
  let result;
  if (!this.form.data.id) {
    result = await saveIndustry({
      id: this.form.data.id,
      title: this.form.data.title,
      detail: this.form.data.detail,
      img: this.form.data.img,
      release: this.form.data.release,
    });
  } else {
    result = await updateIndustry({
      id: this.form.data.id,
      title: this.form.data.title,
      detail: this.form.data.detail,
      img: this.form.data.img,
      release: this.form.data.release,
    });
  }
  if (result.code === 1200) {
    this.$router.push({
      path: '/tab',
    });
  }
}

function back() {
  this.$router.go(-1);
}

function timestampToTime(timestamp) {
  const date = new Date(timestamp);
  // 有三种方式获取
  const time1 = date.getTime();
  return time1;
}

// 工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  ['blockquote', 'code-block'],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
  [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  [{ direction: 'rtl' }], // text direction

  [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ['link', 'image', 'video'],
  ['clean'], // remove formatting button
];
export default {
  name: 'newsEdit',
  data() {
    return {
      imageUrl: '',
      form: {
        data: {
          id: '',
          title: '',
          detail: '',
          img: '',
          release: '',
        },
      },
      quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示,
      editorOption: {
        placeholder: '',
        theme: 'snow', // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image(value) {
                if (value) {
                  // 触发input框选择图片文件
                  document.querySelector('.avatar-uploader input').click();
                } else {
                  this.quill.format('image', false);
                }
              },
            },
          },
        },
      },
    };
  },
  methods: {
    back,
    newsDetails,
    timestampToTime,
    compareImage,
    beforeAvatarUpload,
    handleImageSuccess,
    getLast3Str,
    saveContent,
    // 上传图片前
    beforeUpload() {
      // 显示loading动画
      this.quillUpdateImg = true;
    },
    // 上传图片成功
    uploadSuccess(res) {
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      const { quill } = this.$refs.myQuillEditor;
      // 如果上传成功
      if (res.code === 1200 && res.data.path !== null) {
        // 获取光标所在位置
        const length = quill.getSelection().index;
        // 插入图片  res.info为服务器返回的图片地址
        quill.insertEmbed(length, 'image', `api${res.data.path}`);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        this.$message.error('图片插入失败');
      }
      // loading动画消失
      this.quillUpdateImg = false;
    },
    // 上传图片失败
    uploadError(res, file) {
      console.log('res', res);
      console.log('file', file);
      // loading动画消失
      this.quillUpdateImg = false;
      this.$message.error('图片插入失败');
    },
  },
  created() {
    this.newsDetails();
  },
  components: {
    quillEditor,
    TouchHeader,
  },
};
</script>

<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }


</style>
<style>
  .el-upload {
    border: 1px dashed #d9d9d9;
  }

  .el-form-item__content {
    line-height: 0 !important;
    width: 1200px;
  }

  .ql-toolbar.ql-snow {
    text-align: left;
  }

  .ql-toolbar.ql-snow + .ql-container.ql-snow {
    height: 300px;
  }

  .ql-snow .ql-picker-options .ql-picker-item {
    padding-bottom: 22px;
    padding-top: 13px;
  }
</style>
